(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dorimo-promo-banners"] && !Shopify.designMode) return;
  try {
    
  // Kampanya bantı — oklarla ve otomatik olarak kayan şerit.
  const AUTOPLAY_DELAY = 5000;

  document.querySelectorAll('[data-promo-track]').forEach((track) => {
    const viewport = track.closest('.dorimo-promo-banners__viewport');
    if (!viewport) return;

    const arrows = viewport.querySelectorAll('[data-promo-arrow]');
    if (!arrows.length) return;

    const step = () => {
      const item = track.querySelector('.dorimo-promo-banners__item');
      return item ? item.getBoundingClientRect().width + 18 : track.clientWidth * 0.8;
    };

    // Şerit taşmıyorsa (tüm bantlar ekrana sığıyorsa) ok göstermenin anlamı yok.
    const maxScroll = () => track.scrollWidth - track.clientWidth;

    // Şerit 2px iç boşluklu ve scroll-snap'li olduğu için uç değerler tam 0 /
    // tam maxScroll olmuyor; birkaç piksellik pay bırakıyoruz.
    const EDGE_TOLERANCE = 6;

    const refresh = () => {
      const limit = maxScroll();
      viewport.classList.toggle('is-static', limit <= EDGE_TOLERANCE);
      arrows.forEach((arrow) => {
        const atStart = track.scrollLeft <= EDGE_TOLERANCE;
        const atEnd = track.scrollLeft >= limit - EDGE_TOLERANCE;
        arrow.disabled = arrow.dataset.promoArrow === 'prev' ? atStart : atEnd;
      });
    };

    arrows.forEach((arrow) => {
      arrow.addEventListener('click', () => {
        const direction = arrow.dataset.promoArrow === 'prev' ? -1 : 1;
        track.scrollBy({ left: step() * direction, behavior: 'smooth' });
        stop();
      });
    });

    track.addEventListener('scroll', refresh, { passive: true });
    window.addEventListener('resize', refresh);
    refresh();

    // Otomatik kayma: sona gelince başa döner. Fare üzerindeyken veya
    // kullanıcı hareket azaltma istediğinde durur.
    let timer;
    const stop = () => window.clearInterval(timer);
    const start = () => {
      stop();
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      timer = window.setInterval(() => {
        const limit = maxScroll();
        if (limit <= EDGE_TOLERANCE) return;
        const atEnd = track.scrollLeft >= limit - EDGE_TOLERANCE;
        track.scrollTo({ left: atEnd ? 0 : track.scrollLeft + step(), behavior: 'smooth' });
      }, AUTOPLAY_DELAY);
    };

    viewport.addEventListener('mouseenter', stop);
    viewport.addEventListener('mouseleave', start);
    viewport.addEventListener('focusin', stop);
    viewport.addEventListener('touchstart', stop, { passive: true });
    start();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
